import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Html5QrcodeScanner, Html5QrcodeScanType } from "html5-qrcode";
import { Button } from "primereact/button";

/* eslint-disable-next-line */
export interface ScanProps {}

export function Scan(props: ScanProps) {
  let html5QrcodeScanner: any;

  const navigate = useNavigate();
  const [scanResult, setScanResult] = useState("");

  useEffect(() => {
    if (!html5QrcodeScanner?.getState()) {
      html5QrcodeScanner = new Html5QrcodeScanner(
        "reader",
        {
          fps: 10,
          qrbox: { width: 550, height: 550 },
          supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
        },
        false
      );
      html5QrcodeScanner.render(success, undefined);
    }

    function success(result: any) {
      html5QrcodeScanner.clear();
      const data = (result as string).split(":");

      if (data.length < 3) {
        handleReturn();
        return;
      }

      const transactionCode = data[0];
      const type = data[1];
      const code = data[2];

      clearQr();
      navigate(
        `../${transactionCode}/?action=complete&memberType=${type}&code=${code}`
      );
      setScanResult(result);
    }
  }, []);

  const handleReturn = () => {
    clearQr();
    navigate("../");
  };

  const clearQr = () => {
    if (html5QrcodeScanner) {
      html5QrcodeScanner
        .clear()
        .then((x: any) => {})
        .catch((error: any) => {
          console.error("Failed to clear html5QrcodeScanner. ", error);
        });
    }
  };

  return (
    <div id="Scan">
      {scanResult ? (
        <section className="flex flex-col justify-center items-center">
          <h1>Thank you, for scanning.</h1>
        </section>
      ) : (
        <div id="reader"></div>
      )}
      <div className="flex w-full justify-center">
        <Button
          className="mt-4"
          severity="secondary"
          label="Return"
          onClick={() => handleReturn()}
          outlined
        />
      </div>
    </div>
  );
}

export default Scan;
